"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../../context");

var _utils = require("../../../utils");

var _constants = require("../constants");

var _YearButton = _interopRequireDefault(require("./YearButton"));

var _constants2 = require("./constants");

var _helperComponents = require("./helperComponents");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YearPicker = function YearPicker(_ref) {
  var currentYear = _ref.currentYear,
      goToMonth = _ref.goToMonth,
      hideYearPicker = _ref.hideYearPicker,
      _ref$maxYear = _ref.maxYear,
      maxYear = _ref$maxYear === void 0 ? _constants2.YEAR_PICKER_DEFAULT_PROPS.maxYear : _ref$maxYear,
      _ref$minYear = _ref.minYear,
      minYear = _ref$minYear === void 0 ? _constants2.YEAR_PICKER_DEFAULT_PROPS.minYear : _ref$minYear,
      month = _ref.month,
      triggerButtonRef = _ref.triggerButtonRef,
      _ref$yearPickerButton = _ref.yearPickerButtonAltText,
      yearPickerButtonAltText = _ref$yearPickerButton === void 0 ? _constants.datePickerCalendarDefaultProps.yearPickerButtonAltText : _ref$yearPickerButton;
  var yearRange = {
    min: minYear,
    max: maxYear
  };
  var boundedCurrentYear = (0, _utils2.getYearInAvailableBounds)(currentYear, yearRange);

  var _useState = (0, _react.useState)(boundedCurrentYear),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focusedYear = _useState2[0],
      setFocusedYear = _useState2[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      isRTL = _useContext.isRTL;

  var hiddenTextId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)('dialog-hidden-text-');
  }, []);

  var handleHideYearPicker = function handleHideYearPicker() {
    var _triggerButtonRef$cur;

    hideYearPicker();
    triggerButtonRef === null || triggerButtonRef === void 0 ? void 0 : (_triggerButtonRef$cur = triggerButtonRef.current) === null || _triggerButtonRef$cur === void 0 ? void 0 : _triggerButtonRef$cur.focus();
  };

  var handleYearClick = function handleYearClick(year) {
    goToMonth(month, year);
    handleHideYearPicker();
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case _utils.EventKeys.TAB:
        setFocusedYear(boundedCurrentYear);
        event.preventDefault();
        break;

      case _utils.EventKeys.ESCAPE:
        event.preventDefault();
        event.stopPropagation();
        handleHideYearPicker();
        break;

      case _utils.EventKeys.ARROW_UP:
        setFocusedYear(function (year) {
          return year - _constants2.YEARS_IN_ROW;
        });
        event.preventDefault();
        break;

      case _utils.EventKeys.ARROW_DOWN:
        setFocusedYear(function (year) {
          return year + _constants2.YEARS_IN_ROW;
        });
        event.preventDefault();
        break;

      case _utils.EventKeys.ARROW_LEFT:
        setFocusedYear(function (year) {
          return year + (isRTL ? 1 : -1);
        });
        event.preventDefault();
        break;

      case _utils.EventKeys.ARROW_RIGHT:
        setFocusedYear(function (year) {
          return year + (isRTL ? -1 : 1);
        });
        event.preventDefault();
        break;

      default:
        break;
    }
  };

  var allYears = Array.from({
    length: maxYear - minYear + 1
  }, function (_, y) {
    return minYear + y;
  });
  return (0, _core.jsx)(_helperComponents.YearRow, {
    "aria-labelledby": hiddenTextId,
    "aria-modal": "true",
    flexWrap: "wrap",
    gridGap: _constants2.YEAR_PICKER_ROWS_GAP,
    justifyContent: "flex-start",
    maxHeight: _constants.CALENDAR_HEIGHT,
    maxWidth: _constants.CALENDAR_WRAPPER_MAX_WIDTH,
    padding: _constants2.YEAR_PICKER_ROWS_GAP,
    role: "dialog"
  }, allYears.map(function (year) {
    return (0, _core.jsx)(_YearButton.default, {
      hasFocus: year === focusedYear,
      isCurrentYear: year === boundedCurrentYear,
      key: year,
      onClick: handleYearClick,
      onKeyDown: handleKeyDown,
      year: year
    });
  }), (0, _core.jsx)("span", {
    hidden: true,
    id: hiddenTextId
  }, yearPickerButtonAltText));
};

var _default = YearPicker;
exports.default = _default;